import { MANIFEST } from '../TranscriptApp/tools/transcript_create';
import { schemaToParameters } from '../../utils/schemaToParameters';
import type { SelfContainedCommand } from '../../types/commands';

export const transcript_create: SelfContainedCommand = {
  id: MANIFEST.name,
  description: MANIFEST.description,
  schema: { parameters: schemaToParameters(MANIFEST.inputSchema) },
  handler: async (params, context) => {
    const { callToolRuntime } = await import('../../utils/callToolRuntime');
    return callToolRuntime('transcript_create', params, context);
  },
};
